export default __webpack_public_path__ + "public/assets/images/013b9dc980b25a0257fb8733d5deb2a8.png";